module.exports = {
    "id": "id",
    "label": "Indonesian",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":"Tautan Tidak Valid",
        "INVALID_LINK_TEXT":"Silakan gunakan link berhenti berlangganan di email Anda untuk berhenti berlangganan dari milis kami.",
"UNSUBSCRIBE_ARE_YOU_SURE":"Apakah Anda yakin ingin berhenti berlangganan email ini dari milis kami?",
"UNSUBSCRIBE_CLICK_CONFIRM":"Klik tombol \"Unsubscribe\" di bawah ini untuk mengkonfirmasi.",
"YOU_HAVE_BEEN_UNSUBSCRIBED":"Anda sudah <b>berhenti berlangganan</b> dari milis kami.",
"UNSUBSCRIBED_IN_ERROR":"Jika terdapat error / kesalahan saat berhenti berlangganan, mohon klik <a href='/resubscribe' class='resubscribe'> tautan</a>kembali berlangganan .",
"CANCELLED_STILL_SUBSCRIBED":"<b> Dibatalkan.</b> Anda masih <b>berlangganan</b> pada milis kami.",
"THANK_YOU_FOR_CONTINUING":"Terima kasih untuk terus berpartisipasi dalam survei kami.",
"EMAIL_ALREADY_UNSUBSCRIBED":"Email ini sudah <b>berhenti berlangganan</b> dari milis kami.",
"CLICK_RESUBSCRIBE_TO_REJOIN":"Klik tombol \"kembali berlangganan\" di bawah ini untuk bergabung kembali dalam milis kami.",
"YOU_HAVE_BEEN_RESUBSCRIBED":"Anda sudah <b>kembali berlangganan</b> dalam milis kami.",
"YOU_ARE_ALREADY_SUBSCRIBED":"Anda sudah <b>berlangganan</b> ke dalam milis kami.",
"THANK_YOU_FOR_PARTICIPATING":"Terima kasih untuk terus berpartisipasi dalam survei kami.",
"CHECKING": "Memeriksa...",
"UNSUBSCRIBE":"Berhenti berlangganan",
"RESUBSCRIBE":"Kembali berlangganan",
"EMAIL":"Email",
"CANCEL":"Batal"


    }
};

